import { Component as ComponentContainer } from '@styles/layout';
import { VideoGuideComponent } from '@model/content';
import { VideoGuideCarousel } from '@components/guides';

export const VideoGuideContainer = ({ path, tripType, guides, destination }: VideoGuideComponent) => {
  return (
    <ComponentContainer>
      <VideoGuideCarousel path={path} destination={destination} tripType={tripType} guides={guides} />
    </ComponentContainer>
  );
};
